import { put } from 'redux-saga/effects';
import { FabricationPurchaseOrderService } from '../../../services/FabricationPurchaseOrder';

import { sendTagging } from '../tagging/actions';
import { addToast } from '../toast/actions';
import { EToastTypes } from '../toast/types';
import {
  sendFabricationPurchaseOrderSuccess,
  sendFabricationPurchaseOrderFailure
} from './actions';
import { IFabricationPurchaseOrderState, Types } from './types';
import { handleCopyAndEmail } from '../../../utils/formatStrings';

interface ISendFabricationPurchaseOrderParams {
  payload: {
    fabricationPurchaseOrderState: IFabricationPurchaseOrderState;
  };
  type: Types;
}

export function* sendFabricationPurchaseOrderSaga(
  params: ISendFabricationPurchaseOrderParams
) {
  try {
    const { fabricationPurchaseOrderState } = params.payload;
    const fabricationPurchaseOrderService =
      new FabricationPurchaseOrderService();
    const createdOrderId: number =
      yield fabricationPurchaseOrderService.sendFabricationPurchaseOrder(
        fabricationPurchaseOrderState
      );
    yield put(sendFabricationPurchaseOrderSuccess(createdOrderId));
  } catch (err) {
    console.error('sendFabricationPurchaseOrderSaga', err);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((err as any)?.response?.data?.status === '400') {
      const messages: string[] =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values((err as any)?.response?.data?.errors || []);
      for (let i = 0; i < messages.length; i++) {
        if (typeof messages[i] === 'string')
          yield put(
            addToast({
              message:
                'Ocorreu um erro inesperado, tente novamente em alguns instantes. Se o problema persistir, entre em contato com o suporte', //messages[i],
              type: EToastTypes.DANGER
            })
          );
      }
    } else {
      yield put(
        sendTagging({
          screenName: 'LG:Comprar:CorteEDobra:RevisaoDoPedido',
          event: 'error',
          itemName: `error:enviar_pedido`,
          itemDescription: `comprar_corteEDobra_revisaoDoPedido_erroEnviarPedido`,
          nonInteraction: true
        })
      );
      yield put(
        addToast({
          message:
            'Ocorreu um erro inesperado, tente novamente em alguns instantes. Se o problema persistir, entre em contato com o suporte',
          type: EToastTypes.DANGER,
          labelActionOne: 'CONTATAR SUPORTE',
          durationInMS: 5000,
          handleClickActionOne: handleCopyAndEmail
        })
      );
    }
    yield put(sendFabricationPurchaseOrderFailure(err));
  }
}
